<template>
  <div
    :class="[$style.status, !label && $style.no_label]"
    :style="{
      backgroundColor,
      color
    }"
  >
    {{ label }}
  </div>
</template>

<script>
import statusSelect from "../../select/statusSelect/statusSelect.vue";

export default {
  name: 'StatusCell',
  components: { statusSelect },
  props: ['context'],
  data() {
    return {
      locale: __
    }
  },
  computed: {
    originalValue() {
      return this.context.row.original.status;
    },
    label() {
      return this.originalValue.label;
    },
    color() {
      return this.originalValue.labelColor;
    },
    backgroundColor() {
      return this.originalValue.backgroundColor;
    },
  }
}
</script>

<style module src="./less/statusCell.less"></style>
